import { GrowthDashboardTopBarActions, SchemaManagerView } from '@elva/ui';
import { useCallback } from 'react';
import { AsyncBoundary } from '@/components/feedback';
import { usePageTopBar } from '@/app/layouts/pageTopBar';
import { viewProps } from '@/data/viewProps';
import { useSchema, useSchemaMutations } from '../hooks/useSchema';

export function SchemaPage() {
  usePageTopBar({
    actions: <GrowthDashboardTopBarActions />,
  });

  const { data, isPending, isError, error, refetch, isRefetching, isFetching } = useSchema();
  const { install, markDeployed } = useSchemaMutations();

  const handleHandoff = useCallback(
    (pageId: number) => {
      install.mutate(pageId);
    },
    [install],
  );

  const handleMarkDeployed = useCallback(
    (pageId: number) => {
      markDeployed.mutate(pageId);
    },
    [markDeployed],
  );

  return (
    <AsyncBoundary
      loading={isPending}
      error={data === undefined && isError ? error : undefined}
      onRetry={refetch}
      retrying={isRefetching}
    >
      <SchemaManagerView
        {...viewProps({
          items: data?.items ?? [],
          install: data?.install,
          validation: data?.validation,
          metrics: data?.metrics,
          loading: isFetching || install.isPending || markDeployed.isPending,
          onHandoff: handleHandoff,
          onMarkDeployed: handleMarkDeployed,
          handoffPageId: install.isPending ? install.variables : undefined,
          markingPageId: markDeployed.isPending ? markDeployed.variables : undefined,
        })}
      />
    </AsyncBoundary>
  );
}
